var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1B1F27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28776 4.89058C9.28778 4.67488 9.46052 4.50002 9.67361 4.5H14.3034C14.5165 4.50002 14.6893 4.67488 14.6893 4.89058V6.84231H18.9333C19.7816 6.84231 20.4771 7.54623 20.4771 8.40499V10.1168L19.9431 10.3872C17.4767 11.3218 15.1837 11.7461 13.1455 11.8736V11.1398C13.1455 10.9241 12.9728 10.7492 12.7597 10.7492H11.2174C11.0043 10.7492 10.8316 10.9241 10.8315 11.1398V11.8969C6.66035 11.7148 4.05805 10.3987 4.05805 10.3987L3.5 10.1164V8.40499C3.5 7.54623 4.19541 6.84231 5.04378 6.84231H9.28776V4.89058ZM13.9177 5.28115H10.0596V6.84231H13.9177V5.28115ZM3.5 10.9899V17.7799C3.5 18.6387 4.19541 19.3411 5.04378 19.3411H18.9333C19.7816 19.3411 20.4771 18.6387 20.4771 17.7799V10.9906L20.2449 11.1081L20.2265 11.1138C17.661 12.0877 15.2696 12.527 13.1455 12.6556V13.4825C13.1455 13.6982 12.9728 13.873 12.7597 13.873H11.2174C11.0043 13.873 10.8316 13.6982 10.8315 13.4825V12.6773C6.48971 12.4931 3.71327 11.0978 3.71327 11.0978L3.5 10.9899ZM11.6016 13.0919V11.5304H12.3736V13.0919H11.6016Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUPortfolio);
export default __webpack_public_path__ + "static/media/u_portfolio.2cd10223.svg";
export { ForwardRef as ReactComponent };